import type { CarEventData, InsurancePolicy } from './types.ts'

/** Each event type's own name for its counterparty - the journal payee is this, not a
 * second question. Types with no counterparty field (CAR_WASH, PARKING, MILEAGE_LOG,
 * SELL, BUY) derive nothing; the field stays blank until typed. */
export function counterpartyFor(
  data: CarEventData,
  policies: readonly InsurancePolicy[],
): string | undefined {
  switch (data.type) {
    case 'FUEL':
      return data.fuelStation
    case 'REPAIR':
      return data.repairShop
    case 'INSPECTION':
      return data.station
    case 'TIRE_CHANGE':
      return data.shop
    case 'TAX':
    case 'REGISTRATION':
    case 'FINE':
      return data.authority
    case 'INSURANCE_PAYMENT':
      return policies.find((policy) => policy.id === data.policyId)?.insurer
    default:
      return undefined
  }
}
